import { api } from "api";
import {
    getDeliveryOffersData,
    addDeliveryOffer,
    editDeliveryOffer,
    deleteDeliveryOffer,
} from "api/apiURLs";

export const getDeliveryOffers = async () => {
    const response = await api.get(getDeliveryOffersData);
    return response.data;
};

export const createDeliveryOffer = async (data) => {
    const response = await api.post(addDeliveryOffer, data);
    return response.data;
};

export const updateDeliveryOffer = async ({ id, ...data }) => {
    const response = await api.patch(`${editDeliveryOffer}${id}`, data);
    return response.data;
};

export const removeDeliveryOffer = async (id) => {
    const response = await api.delete(`${deleteDeliveryOffer}${id}`);
    return response.data;
};
